var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: "24px",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    width: "24px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128,112c0,8.8-7.2,16-16,16H16c-8.8,0-16-7.2-16-16V16C0,7.2,7.2,0,16,0h96c8.8,0,16,7.2,16,16V112z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.122,46.404c0,0-0.86-6.064-3.499-8.733c-3.348-3.506-7.098-3.523-8.816-3.728  c-12.312-0.891-30.787-0.891-30.787-0.891h-0.04c0,0-18.474,0-30.787,0.891c-1.721,0.204-5.469,0.221-8.816,3.728  c-2.639,2.669-3.498,8.733-3.498,8.733S20,53.525,20,60.647v6.677c0,7.119,0.879,14.242,0.879,14.242s0.859,6.062,3.498,8.732  c3.348,3.508,7.745,3.396,9.702,3.764c7.041,0.676,29.922,0.885,29.922,0.885s18.49-0.028,30.806-0.918  c1.721-0.206,5.471-0.223,8.817-3.729c2.64-2.672,3.499-8.733,3.499-8.733S108,74.445,108,67.324v-6.677  C108,53.525,107.122,46.404,107.122,46.404 M53.802,76.569l-0.003-27.038l26,13.565L53.802,76.569z",
    fill: "#141D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ed1d1c272483eb84a274d332a75194d6.svg";
export { ForwardRef as ReactComponent };